// react
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box } from '@mui/material';
// components
import Loading from './Loading';

// ----------------------------------------------------------------------

const IS_PRODUCTION = process.env.REACT_APP_IS_PRODUCTION;

const Page = forwardRef(({ isLoading, children, title, meta, ...other }, ref) => (
  <>
    <Helmet>
      <title>{`${title} | Sporexpert`}</title>
      {meta}
    </Helmet>

    <Box ref={ref} {...other}>
      {isLoading ? <Loading /> : children}
    </Box>
  </>
));

Page.propTypes = {
  meta: PropTypes.node,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Page.defaultProps = {
  title: '',
  meta: null,
  isLoading: false,
};

export default Page;